import { createContext, useContext } from 'react';

// Permite que el contenido hardcodeado de journeyContent.tsx (ClickableTerm) dispare el panel de
// detalle sin tener que threadear un callback a través de cada JourneyResource.body.
export const JourneyGlossaryContext = createContext<(termKey: string) => void>(() => undefined);

export function useJourneyGlossary() {
  return useContext(JourneyGlossaryContext);
}
